import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import  { NAV_MENU_ITEMS } from "./nav-menu.constant";
import { ApiService } from "@shared/services/api.service";
import { Urls } from "@utils/urls";
import * as moment from 'moment';


@Component({
  selector: "app-nav-menu",
  templateUrl: "./nav-menu.component.html",
  styleUrls: ["./nav-menu.component.scss"],
})
export class NavMenuComponent implements OnInit {
  menuItems = [];

  constructor(
    public activeModal: NgbActiveModal,
    public router: Router,
    private apiService: ApiService
  ) {}

  ngOnInit() {
    this.menuItems = NAV_MENU_ITEMS;
    this.getFundDetails();
  }

  closePop() {
    this.activeModal.close();
  }

  navPage = (url) => {
    this.activeModal.close();
  };

  getFundDetails() {
    const obj = {};
    const nfoMenu  = this.menuItems.find((i) => i.displayName === "NFO");
    this.apiService.postData(Urls.getTop3Funds, obj).subscribe(
      (response) => {
        const fundDetailsList = response.data.returnValue;
        const currentData = moment().format("YYYY-MM-DD");
        const fundDetail = fundDetailsList.find((fd) => {
         return fd.isNfo.toLowerCase() === "yes" && moment(fd.endDate).diff(currentData, 'days') >= 0
        });
        nfoMenu.disabled = !fundDetail;
      },
      (error) => {
        nfoMenu.disabled = true;
      }
    );
  }
}
